// Configuración de galaxias (data-driven y modular).
// Para añadir futuras galaxias (Fracciones, Decimales, etc.) basta con agregar
// otro objeto a GALAXIES con sus planetas; la navegación no necesita reconstruirse.

import { HEX, CSS } from '../config';

export const GALAXY_1 = {
  id: 'g1',
  name: 'Galaxia de las Operaciones Aritméticas',
  planets: [
    {
      id: 'suma',
      name: 'Sistema Estelar de la Suma',
      symbol: '+',
      color: HEX.cyan,
      css: CSS.cyan,
      x: 300,
      y: 360,
      ring: false,
      unlocked: true,
      scene: 'LevelScene',
    },
    {
      id: 'resta',
      name: 'Sistema Estelar de la Resta',
      symbol: '−',
      color: HEX.magenta,
      css: '#ff5fcf',
      x: 560,
      y: 300,
      ring: true,
      unlocked: true,
      scene: 'LevelScene',
    },
    {
      id: 'mult',
      name: 'Sistema Estelar de la Multiplicación',
      symbol: '×',
      color: HEX.gold,
      css: CSS.gold,
      x: 830,
      y: 380,
      ring: false,
      unlocked: true,
      scene: 'LevelScene',
    },
    {
      id: 'division',
      name: 'Sistema Estelar de la División',
      symbol: '÷',
      color: 0x72fff6,
      css: '#72fff6',
      x: 1080,
      y: 310,
      ring: true,
      unlocked: true,
      scene: 'LevelScene',
    },
  ],
};

export const GALAXIES = [GALAXY_1];
